import { ItemCard } from "./grid-filter/views/Item-Card";
import { Item } from "./grid-filter/models/item";
import { Items } from "./grid-filter/collections/items";
import { Filter } from "./grid-filter/models/filter";
import { FilterBar } from "./grid-filter/views/Filter-Bar";


(function($){
    $( document ).ready(function(){
        let filter = new Filter();
        let homes = new Items();
        let filterTemplate = _.template( document.getElementById('item-filter-option-template').innerHTML );
        let filterBar = new FilterBar( { 'el' : $( '#homes-filter'), model: filter, collection: homes, template: filterTemplate } );
        filterBar.render();
        filterBar.template = filterTemplate;
        
        $('.home-card').each( function(){

            var props = JSON.parse( this.dataset.properties );

            filter.registerFilters( props );

            let home = new Item( props );

            var view = new ItemCard({ el : $(this), model: home });
            view.render();

            homes.add( home );
        });

        filterBar.buildFilters();

    });
})(jQuery);